<router-outlet></router-outlet>

<app-idle-dialog></app-idle-dialog>

<pos-confirm-dialog></pos-confirm-dialog>

